module.exports = __webpack_public_path__ + "static/media/1.e44d471e.jpg";